import { detect } from "detect-browser";

const browser = detect();

export default function detectBrowser() {
  switch (browser && browser.name) {
    case "ie":
      return "ie";
    default:
      return false;
  }
}
